import React from 'react';
import { Container } from 'react-bootstrap';
import HTMLFlipBook from 'react-pageflip';

// Список изображений для книги
const images = [
  '/projects/harry-potter/20250930_110153.jpg',
  '/projects/harry-potter/20250930_110202.jpg',
  '/projects/harry-potter/20250930_110321.jpg',
  '/projects/harry-potter/20250930_110403.jpg',
  '/projects/harry-potter/20250930_110414.jpg',
  '/projects/harry-potter/20250930_110427.jpg',
  '/projects/harry-potter/20250930_110449.jpg',
  '/projects/harry-potter/20250930_110457.jpg',
  '/projects/harry-potter/20250930_110535.jpg',
  '/projects/harry-potter/20250930_110545.jpg',
  '/projects/harry-potter/20250930_110633.jpg',
  '/projects/harry-potter/20250930_110649.jpg',
  '/projects/harry-potter/20250930_110701.jpg',
  '/projects/harry-potter/20250930_110729.jpg'
];

const Page = React.forwardRef((props, ref) => {
    return (
        <div className="page" ref={ref}>
            <img src={props.src} alt={`Page ${props.number}`} style={{width: '100%', height: '100%', objectFit: 'cover'}} />
        </div>
    );
});

function ProjectHarryPotter() {
  return (
    <Container className="mt-4 text-center">
      <h1>Проект: Гарри Поттер и тайная комната</h1>
      <p>Волшебный мир Гарри Поттера глазами наших учеников.</p>
      
      <div className="d-flex justify-content-center mb-4">
        <HTMLFlipBook width={500} height={700} showCover={true}>
          {images.map((src, index) => (
            <Page key={index} number={index + 1} src={src} />
          ))}
        </HTMLFlipBook>
      </div>

      <hr />

      <h2>Видео-обзор книги</h2>
      <div className="d-flex justify-content-center">
        <video width="80%" controls>
          <source src="/projects/harry-potter/20250524_141937.mp4" type="video/mp4" />
          Ваш браузер не поддерживает проигрывание видео.
        </video>
      </div>
      <p className="mt-2">Эту книжку делал ученик школы Krayonika.</p>

    </Container>
  );
}

export default ProjectHarryPotter;
